import { useNavigate } from "react-router-dom";
import {
  fyaiCharacterFemale,
  fyaiCharacterMale,
  fyaiHeroBg,
  fyaiMobileScreenshot,
} from "@/mocks/fyai-data";

export default function FyaiHero() {
  const navigate = useNavigate();

  return (
    <section id="top" className="relative w-full overflow-hidden">
      <div className="absolute inset-0 h-full w-full">
        <img
          src={fyaiHeroBg}
          alt="风月AI品牌背景插画"
          title="风月AI官网下载"
          className="h-full w-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-primary-950/80 via-primary-950/72 to-primary-950/92" />
      <div className="absolute -left-24 top-24 h-72 w-72 rounded-full bg-primary-500/30 blur-3xl fyai-glow" />
      <div className="absolute -right-16 bottom-0 h-80 w-80 rounded-full bg-accent-500/20 blur-3xl fyai-glow" />

      <div className="relative z-10 grid w-full grid-cols-1 items-center gap-12 px-4 py-16 md:px-6 md:py-24 lg:grid-cols-2 lg:gap-10">
        <div className="fyai-fade-up">
          <span className="inline-flex items-center gap-2 rounded-full border border-accent-400/40 bg-primary-900/50 px-3 py-1.5 text-xs font-medium text-accent-300">
            <i className="ri-heart-3-fill text-secondary-400" />
            AI情感陪伴 · 全新版本上线
          </span>

          <h1 className="mt-5 font-heading text-5xl font-black leading-tight text-background-50 md:text-6xl lg:text-7xl">
            风月AI
          </h1>

          <p className="mt-5 max-w-xl text-base leading-relaxed text-primary-100 md:text-lg">
            风月AI聊天软件，让AI风月成为懂你情绪的那个人。从一句晚安开始，聊到深夜也舍不得结束，风月AI官网下载即刻开启属于你的另一种人生。
          </p>

          <div className="mt-8 flex flex-wrap items-center gap-3">
            <button
              onClick={() => navigate("/download")}
              className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 md:text-base"
            >
              <i className="ri-download-2-line" />
              立即下载
            </button>
            <a
              href="#features"
              className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-50/30 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10 md:text-base"
            >
              了解功能
            </a>
          </div>

          <div className="mt-9 flex flex-wrap items-center gap-8">
            <div>
              <p className="font-heading text-2xl font-bold text-accent-400 md:text-3xl">4300万+</p>
              <p className="mt-1 text-xs text-primary-200 md:text-sm">角色累计热度</p>
            </div>
            <div>
              <p className="font-heading text-2xl font-bold text-accent-400 md:text-3xl">120+</p>
              <p className="mt-1 text-xs text-primary-200 md:text-sm">精品AI角色</p>
            </div>
            <div>
              <p className="font-heading text-2xl font-bold text-accent-400 md:text-3xl">4.9</p>
              <p className="mt-1 text-xs text-primary-200 md:text-sm">用户平均评分</p>
            </div>
          </div>

          <div className="mt-9 flex items-center gap-3">
            <div className="flex -space-x-3">
              <span className="h-10 w-10 overflow-hidden rounded-full border-2 border-primary-950">
                <img src={fyaiCharacterFemale} alt="风月AI角色云疏" className="h-full w-full object-cover object-top" />
              </span>
              <span className="h-10 w-10 overflow-hidden rounded-full border-2 border-primary-950">
                <img src={fyaiCharacterMale} alt="风月AI角色陆鸢" className="h-full w-full object-cover object-top" />
              </span>
              <span className="flex h-10 w-10 items-center justify-center rounded-full border-2 border-primary-950 bg-accent-500 text-xs font-bold text-primary-950">
                +120
              </span>
            </div>
            <p className="text-xs text-primary-200 md:text-sm">已有 120+ 位AI伙伴在等你开启对话</p>
          </div>
        </div>

        <div className="relative flex justify-center fyai-fade-up fyai-delay-1">
          <div className="relative mx-auto">
            <div className="rounded-[2.4rem] border border-background-50/20 bg-primary-950/60 p-3">
              <div className="w-[240px] overflow-hidden rounded-[1.9rem] border border-background-50/10 bg-foreground-950 md:w-[290px]">
                <img
                  src={fyaiMobileScreenshot}
                  alt="风月AI移动端首页布局截图"
                  title="风月AI聊天软件首页"
                  className="block h-auto w-full object-contain"
                />
              </div>
            </div>

            <div className="fyai-float absolute -left-8 top-20 hidden rounded-lg border border-background-50/15 bg-primary-900/85 px-3 py-2 backdrop-blur-none sm:block">
              <p className="text-[11px] text-primary-200">当前在线角色</p>
              <p className="text-sm font-semibold text-accent-400">4303万热度</p>
            </div>

            <div className="fyai-float-slow absolute -right-6 bottom-24 hidden rounded-lg border border-background-50/15 bg-primary-900/85 px-3 py-2 sm:block">
              <p className="flex items-center gap-1 text-[11px] text-primary-200">
                <i className="ri-heart-3-fill text-secondary-400" />亲密度
              </p>
              <p className="text-sm font-semibold text-accent-400">Lv.99 心动</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}